export enum RemoteMethod {
  initialiseBook,
  shutdownBook,
  addBook,
  processCurrencyPairChange,
  notify,
  notifyAdd,
  notifyRemove,
  notifyEntityAmend,
  notifyTrackingAmend,
  reactivateOrdersLocal,
  getOrders,
  flushAndDeactivateLocal,
}

export namespace RemoteMethod {
  let elements = [
    RemoteMethod.initialiseBook,
    RemoteMethod.shutdownBook,
    RemoteMethod.addBook,
    RemoteMethod.processCurrencyPairChange,
    RemoteMethod.notify,
    RemoteMethod.notifyAdd,
    RemoteMethod.notifyRemove,
    RemoteMethod.notifyEntityAmend,
    RemoteMethod.notifyTrackingAmend,
    RemoteMethod.reactivateOrdersLocal,
    RemoteMethod.getOrders,
    RemoteMethod.flushAndDeactivateLocal,
  ];
  let alias = "com.bcdfx.monitor.api.OrderMonitorClusterMessage.RemoteMethod";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
